var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerComponent"},[_c('div',[_vm._v(" Copyright © 2021-2025 极智科技（山东）有限公司 All Rights Reserved. ")]),_c('div',[_vm._v("ICP备案：鲁ICP备20013547号")])])
}]

export { render, staticRenderFns }